import {AbstractUpload} from "./AbstractUpload";
import {Injectable} from "@angular/core";
import LocalDataSource from "../../../data-sources/LocalDataSource";
import {EnumSincronizacao} from "../../../domain/EnumSincronizacao";
import {Especime} from "../../../domain/Especime";
import {EspecimeHttpService} from "../../persist/http/EspecimeHttpService";
import {Jornada} from "../../../domain/Jornada";

@Injectable()
export class UploadEspecime extends AbstractUpload<Especime>{
  constructor(service: EspecimeHttpService) {
    super("Espécime", service, Especime);
  }

  override async getPendencias(): Promise<any[]>{
    const repo = LocalDataSource.getRepository(Especime)
    return repo.find({
      where: {situacao: EnumSincronizacao.ENVIAR},
      relations: ["observadores","meteorologias","taxon","bioma","fitofisionomia","municipio","microRH",
        "monitoramento","comportamento","guia","instituicaoDepositaria","tipoMarcacao","metodoAmostragem"]
    })
  }

  override transformBeforeSend(items: Especime[]): any[]{
    items.forEach(i=>{
      delete i.situacao
    })
    return items
  }
}
